export const CitationOutputTypes = {
  BIBLIOGRAPHY: 'bibliography',
  CITATION: 'citation',
  BIBTEX: 'bibtex',
}
